import classNames from "classnames";
import { Outlet } from "react-router-dom";

export default function ClientPortalLayout() {
  return (
    <div className={classNames("w-full h-full", "flex")}>
      <Outlet />
    </div>
  );
}
